export default {
  1: { label: 'Unconfirmed', color: 'dark' },
  2: { label: 'Pending', color: 'info' },
  3: { label: 'Active', color: 'success' },
};
